module.exports = __webpack_public_path__ + "img/Elite64NorLogo_400x400.5535a669.jpg";